import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rx-badge',
  templateUrl: './rx-badge.component.html',
  styleUrls: ['./rx-badge.component.scss'],
})
export class RxBadgeComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
